import React, { useState, useEffect, Fragment } from 'react';
import MasterBar from '../../components/masterBar';
import Card from '../../components/card';
import TableCompare from '../../components/table';
import ElTabs from '../../components/elTabs';
import AtresBarChart from '../../components/charts/atresBarChart';
import Autocomplete from '../../components/autocomplete/index';
import BreadCrumb from '../../components/breadCrumb/';
import {
  TYPES,
  SUBTYPES,
  CODE_CANARY,
  EXCLUDED_REGIONS
} from '../../envs/core';
import { ResultProvider } from '../../dataProvider/results';
import { getResultOrigin } from '../../dataProvider/origin';
import { getData } from '../../dataProvider/places/single';
import { PlacesProvider, getPlace } from '../../dataProvider/places';
import './details.scss';

const getRoute = (town, electionNumber, year) => {
  const host = window.location.hostname.replace('localhost', 'lasexta');
  if (host.indexOf('lasexta') !== -1) {
    let currentYear = '';
    if (year !== '2019') {
      currentYear = '/' + year;
    }
    return `https://www.lasexta.com/noticias/nacional/elecciones-autonomicas/resultados${currentYear}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
  if (host.indexOf('antena3') !== -1) {
    return `https://www.antena3.com/noticias/elecciones/resultados/elecciones-autonomicas/${year}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
  if (host.indexOf('ondacero') !== -1) {
    let currentYear = '';
    if (year !== '2019') {
      currentYear = '/' + year;
    }
    return `https://www.ondacero.es/noticias/elecciones-municipales-autonomicas/resultados-autonomicas${currentYear}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
};

const AutonomousDetail = ({ match, history }) => {
  const {
    year,
    electionNumber,
    communityId,
    province,
    town,
    reload,
    masterbar
  } = match.params;

  const isCanary = communityId === CODE_CANARY;
  const type = TYPES.REGIONAL;
  const [elSubtype] = useState(isCanary ? SUBTYPES.INSULAR : SUBTYPES.SINGLE);
  const [provinceData, setProvinceData] = useState({});
  const [community, setCommunity] = useState({});
  const [titleTown, setTitleTown] = useState('');
  const [autocomple, setAutocomple] = useState('');
  const [resultOrigin, setResultOrigin] = useState({});
  const [lastYear, setLastYear] = useState();

  useEffect(() => {
    getData(communityId).then(place => {
      setCommunity(place);
    });
  }, [communityId]);

  useEffect(() => {
    getData(town).then(place => {
      setTitleTown(place.name);
    });
  }, [town]);

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, communityId)
      .then(historicResult => {
        setResultOrigin(historicResult);
        setLastYear(historicResult.historic.year);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  useEffect(() => {
    if (town === 'null') {
      getPlace(
        `type=TOWN&parentid=${province}&size=1000&page=0&sortby=population`
      ).then(towns => {
        if (towns && towns.content) {
          const orderedTowns = towns.content.sort((a, b) => {
            if (a.population < b.population) {
              return 1;
            }
            if (a.population > b.population) {
              return -1;
            }
            return 0;
          });
          const child = orderedTowns[0];

          changeLocation(child);
        }
      });
    }
  }, [province, town, community]);

  const changeLocation = child => {
    if (Boolean(parseInt(reload))) {
      const ruta = getRoute(child, electionNumber, year);
      window.location.href = ruta;
    } else {
      history.push(
        `/${masterbar}/${reload}/${year}/${electionNumber}/${child.grandpaId}/${child.parentId}/${child.ineId}/detalleAutonomica.html`
      );
    }
  };

  const goTo = child => {
    let path = '';
    if (Boolean(parseInt(reload))) {
      path = getRoute(child, electionNumber, year);
      window.location.href = path;
    } else {
      if (child) {
        if (child.typePlace === 'REGION') {
          path = `/${masterbar}/${reload}/${year}/${electionNumber}/${child.ineId}/resultadosautonomicos.html`;
        } else if (child.typePlace === 'PROVINCE') {
          path = `/${masterbar}/${reload}/${year}/${electionNumber}/${communityId}/${child.ineId}/resultadosautonomicos.html`;
        }
      } else {
        path = `/${masterbar}/${reload}/${year}/${electionNumber}/resultadosautonomicos.html`;
      }
      history.push(path);
    }
  };

  return resultOrigin && resultOrigin.primary ? (
    <ResultProvider
      electionPlace={communityId}
      year={year}
      active={resultOrigin.primary.active}
      type={type}
      subtype={elSubtype}
      electionNumber={electionNumber}
      placeId={town}
      details={true}
    >
      {dataResult => (
        <div className="pageDetails pageDetails_Autonomicas">
          <div className="mainWrapper">
            {Boolean(parseInt(masterbar)) && (
              <MasterBar
                current="autonomicas"
                history={history}
                reload={reload}
              />
            )}
            <div className="colContainer">
              <div className="floatingBlock left">
                <div className="inner">
                  <BreadCrumb
                    type="AUTONÓMICAS"
                    community={community}
                    province={provinceData}
                    onClick={goTo}
                  />

                  <div className="graphContainer">
                    <div className="selectedTownContainer">
                      <PlacesProvider
                        type="PROVINCE"
                        sortby="name"
                        parentId={communityId}
                        excludedGrandParentIds={EXCLUDED_REGIONS}
                      >
                        {data => {
                          return (
                            setProvinceData(
                              data && data.filter(x => x.ineId === province)[0]
                            ),
                            (
                              <span className="selectedTownTitle">
                                {titleTown}
                              </span>
                            )
                          );
                        }}
                      </PlacesProvider>
                      <PlacesProvider
                        type="TOWN"
                        name={autocomple}
                        sortby={autocomple ? 'score' : 'name'}
                        excludedGrandParentIds={EXCLUDED_REGIONS}
                      >
                        {data => {
                          return (
                            <Autocomplete
                              results={data}
                              onChange={value => setAutocomple(value)}
                              onSelect={select => {
                                changeLocation(select);
                              }}
                              placeholder={'Seleccione localidad'}
                              showArrow
                            />
                          );
                        }}
                      </PlacesProvider>
                    </div>

                    {dataResult &&
                    dataResult.partiesResult &&
                    town !== 'null' ? (
                      <Fragment>
                        <table className="infoTable">
                          <tbody>
                            <tr>
                              <td className="key">Número de votos en: </td>
                              <td colspan="2" className="value">
                                {titleTown}
                              </td>
                            </tr>
                            <tr>
                              <td className="key">Votos contabilizados: </td>
                              <td className="value votes">
                                {Number(dataResult.totalVotes).toLocaleString(
                                  'es'
                                )}
                              </td>
                              <td className="value votes_percent">
                                {Number(
                                  dataResult.currentCountPercent
                                ).toLocaleString('es')}
                                %
                              </td>
                            </tr>
                            <tr>
                              <td className="key">Abstenciones: </td>
                              <td className="value votes">
                                {Number(
                                  dataResult.abstentionVotes
                                ).toLocaleString('es')}
                              </td>
                              <td className="value abstention_percent">
                                {Number(
                                  dataResult.abstentionPercent
                                ).toLocaleString('es')}
                                %
                              </td>
                            </tr>
                            <tr>
                              <td className="key">Votos en blanco: </td>
                              <td className="value whites">
                                {Number(dataResult.whiteVotes).toLocaleString(
                                  'es'
                                )}
                              </td>
                              <td className="value whites_percent">
                                {Number(dataResult.whitePercent).toLocaleString(
                                  'es'
                                )}
                                %
                              </td>
                            </tr>
                            <tr>
                              <td className="key">Votos nulos: </td>
                              <td className="value null">
                                {Number(dataResult.invalidVotes).toLocaleString(
                                  'es'
                                )}
                              </td>
                              <td className="value null_percent">
                                {Number(
                                  dataResult.invalidPercent
                                ).toLocaleString('es')}
                                %
                              </td>
                            </tr>
                            {dataResult.totalSeats && (
                              <tr>
                                <td className="key">Total de escaños: </td>
                                <td className="value votes">
                                  {Number(dataResult.totalSeats).toLocaleString(
                                    'es'
                                  )}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <AtresBarChart
                          data={dataResult.partiesResult || []}
                          dataKey="votesPercent"
                          showLabel={true}
                          seatTotal={dataResult.totalSeats || 0}
                        />
                      </Fragment>
                    ) : (
                      <div>Seleccione una localidad</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="floatingBlock right">
                {dataResult && town !== 'null' && (
                  <div className="inner">
                    <Card
                      title="ESCRUTADO:"
                      titleValue={
                        dataResult.updateDate
                          ? `${Number(
                              dataResult.currentCountPercent
                            ).toLocaleString('es')} %`
                          : 'Cargando...'
                      }
                      subtitle={
                        dataResult.updateDate
                          ? `Actualizado a las: ${dataResult.updateDate.slice(
                              0,
                              -3
                            )}`
                          : 'Cargando...'
                      }
                    >
                      <Fragment>
                        <div className="participationTitle">
                          <span className="key">PARTICIPACIÓN: </span>
                          <span className="value">
                            {dataResult.updateDate
                              ? `${Number(
                                  dataResult.participationPercent
                                ).toLocaleString('es')} %`
                              : 'Cargando...'}
                          </span>
                        </div>
                        <ElTabs titles={['Datos', `${lastYear}`]}>
                          <div>
                            {dataResult.partiesResult && (
                              <TableCompare
                                details
                                hideSeats={true}
                                data={dataResult.partiesResult}
                              />
                            )}
                          </div>
                          <ResultProvider
                            electionPlace={communityId}
                            active={resultOrigin.historic.active}
                            year={resultOrigin.historic.year}
                            type={type}
                            subtype={elSubtype}
                            electionNumber={electionNumber}
                            placeId={town === 'null' ? null : town}
                            details={true}
                          >
                            {oldData => (
                              <div>
                                {oldData.partiesResult && (
                                  <TableCompare
                                    details
                                    hideSeats={true}
                                    data={oldData.partiesResult}
                                  />
                                )}
                              </div>
                            )}
                          </ResultProvider>
                        </ElTabs>
                      </Fragment>
                    </Card>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </ResultProvider>
  ) : (
    <div>Loading</div>
  );
};

export default AutonomousDetail;
